import { useEffect } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';

import { LANDING_URL } from '@/services';

export default function AuthCallbackPage() {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const error = searchParams.get('error');

  useEffect(() => {
    if (error) {
      window.location.replace(LANDING_URL);
      return;
    }

    navigate('/meaning', { replace: true });
  }, [error, navigate]);

  return (
    <div className="min-h-screen bg-gradient-to-br from-purple-50 via-white to-blue-50 flex items-center justify-center">
      <p className="text-gray-600">Completing sign in...</p>
    </div>
  );
}
